import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

// Browser/hardware back from a charging status page (pending payment,
// preparing, active charging) would otherwise drop the user onto a checkout
// page — the forward flow only ever reaches checkout via QR scan or the kWh
// page, never from a status page, so a `from` that is a status page can only
// mean a back press. Send them home instead of into a half-finished checkout
// (which would recalculate the rate and invite a duplicate payment); a pending
// payment can still be resumed from their activity history.
const redirectHomeFromStatusPage = (
  _to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  if (from.meta.chargingStatus) {
    return { name: 'home' }
  }
}

export default [
  {
    path: '/charging/:uuid/preparing',
    name: 'charging.preparing',
    component: () => import('./preparing/PreparingPage.vue'),
    meta: { chargingStatus: true }
  },
  {
    path: '/charging/:connectorId/:chargerId',
    name: 'charging.start',
    component: () => import('./start/ChargingStartPage.vue'),
    beforeEnter: redirectHomeFromStatusPage
  },
  {
    path: '/charging/:connectorId/:chargerId/summary-payment',
    name: 'charging.start.summary-payment',
    component: () => import('./start/SummaryPaymentPage.vue'),
    beforeEnter: redirectHomeFromStatusPage
  },
  {
    path: '/charging/:uuid',
    name: 'charging.detail',
    component: () => import('./detail/ChargingDetailPage.vue'),
    meta: { chargingStatus: true }
  },
  {
    path: '/charging/:uuid/payment',
    name: 'charging.payment-result',
    component: () => import('./payment-result/PaymentResultPage.vue'),
    meta: { chargingStatus: true }
  }
] satisfies RouteRecordRaw[]
